import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { ProjectComponent } from './project/project.component';
import { ProjectItemComponent } from './project/project-item/project-item.component';
import { RegisterComponent } from './register/register.component';
import { DeleteDialogComponent } from './project/edit/delete-dialog/delete-dialog.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { PageNotFoundComponent } from './error/page-not-found/page-not-found.component';
import { ProfileModule } from './profile/profile.module';
import { ProjectModule } from './project/project.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationComponent } from './notification/notification.component';
import { NotificationModule } from './notification/notification.module';
import { StatisticsComponent } from './statistics/statistics.component';
import { EoiDetailDialog } from './project/project-detail/eois/eoi-detail-dialog/eoi-detail-dialog';
import { AddEoiDialog } from './project/project-detail/eois/add-eoi-dialog/add-eoi-dialog';
import { HomeMapComponent } from './home/home-map/home-map.component';
import { HomeFooterComponent } from './home/home-footer/home-footer.component';
import {MatCardModule} from '@angular/material/card';
import { AgentsComponent} from './agents/agents.component';
import { DevelopersComponent } from './developers/developers.component';

/**
 * @class RoutesModule
 * @memberOf AppModule
 * @description This is a high level module which combine different section's components
 */
const COMPONENTS = [
    DashboardComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    ProjectComponent,
    ProjectItemComponent,
    DeleteDialogComponent,
    PageNotFoundComponent,
    NotificationComponent,
    HomeMapComponent,
    HomeFooterComponent,
    AgentsComponent,
    DevelopersComponent
];


@NgModule({
    imports: [
        SharedModule,
        RoutesRoutingModule,
        RouterModule,
        CommonModule,
        ReactiveFormsModule,
        MatTooltipModule,
        NgxEchartsModule,
        NgSelectModule,
        ProfileModule,
        ProjectModule,
        MatGridListModule,
        MatProgressBarModule,
        NotificationModule,
        MatCardModule,
    ],
    declarations: [
        ...COMPONENTS,
        StatisticsComponent
    ],
    providers: [
    ],
    exports: [
    ],
    entryComponents: [
        DeleteDialogComponent,
        EoiDetailDialog,
        AddEoiDialog
    ]
})

export class RoutesModule {
}
